import { Observable } from 'rxjs';
import { Papa } from 'ngx-papaparse';

export function exportCSV(rows: any[], columns: {label: string, field: string }[], includeHeader: boolean = true): Observable<string> {
    const papa = new Papa();
    const exportRows: any[] = [];
    
    // add header
    if (includeHeader) {
        exportRows.push(columns.map(c => c.label));
    }
    
    // add data rows
    rows.forEach((row) => {
        const dataRow = columns.map((col) => row[col.field]);
        exportRows.push(dataRow);
    });
    
    return new Observable<string>((observer) => {
        const csv = papa.unparse(exportRows, { quotes: true, header: false });
        observer.next(csv);
        observer.complete();
    });
}
